import React from "react";
import _ from "lodash";
import classnames from "classnames";
import DayPicker from "react-day-picker";
import format from "date-fns/format";
import getDay from "date-fns/get_day";
import moment from "../../utils/moment-timezone-with-data-2012-2022";
import "react-day-picker/lib/style.css";
import styles from "./index.module.scss";
import localeDates from "../../utils/localeDates";
import ChevronDownIcon from "../icons/ChevronDown.svg";
import { CheckCircle } from "@material-ui/icons";

export default function({
  T,
  appStyles,
  servingOptionTag,
  openCalendar,
  date,
  onDaySelected,
  dateInDisplayFormat,
  onInputClick,
  selectedDate,
  branchAvailability,
  timeZone,
}) {
  const isClosedForToday =
    _.get(branchAvailability, "availability") === "AVAILABLE_LATER" &&
    moment.tz(timeZone).dayOfYear() !==
      moment
        .tz(moment(_.get(branchAvailability, "availableFrom")), timeZone)
        .dayOfYear();

  const renderDay = (day) => {
    const isToday =
      moment.tz(timeZone).dayOfYear() ===
      moment.tz(moment(day), timeZone).dayOfYear();
    const closedForToday = isToday && isClosedForToday;
    const dateStyle = closedForToday
      ? { color: "#D0021B", cursor: "not-allowed" }
      : {};
    const textStyle = {
      fontSize: 10,
      textAlign: "center",
      position: "absolute",
      bottom: -20,
      left: -25,
      width: 70,
    };
    const cellStyle = { position: "relative" };

    return (
      <div style={cellStyle}>
        <div style={{ ...dateStyle }}>{day.getDate()}</div>
        {closedForToday && (
          <div
            style={{
              ...textStyle,
              color: "#D0021B",
            }}
          >
            {T("Closed")}
          </div>
        )}
        {!closedForToday && isToday && (
          <div style={{ ...textStyle, color: "inherit", fontWeight: "bolder" }}>
            {T("Today")}
          </div>
        )}
      </div>
    );
  };
  const closedForTodayMessage = T(`*${servingOptionTag} is closed today`);
  const isToday =
    moment.tz(moment(selectedDate || new Date()), timeZone).dayOfYear() ===
    moment.tz(timeZone).dayOfYear();

  return (
    <div style={{ marginTop: 20 }}>
      <div
        style={{
          paddingTop: 4,
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div>{T(`${servingOptionTag} Date`)}:</div>
        {isClosedForToday && (
          <div
            style={{ color: "#D0021B", fontSize: "0.7rem" }}
          >{`${closedForTodayMessage}`}</div>
        )}
      </div>
      <div>
        <div
          className={styles.DateInputDesktop}
          style={{
            borderRadius: appStyles.inputBorderRadius,
            ...appStyles.Input,
            ...(appStyles.inputValidColor && {
              border: `1px solid ${appStyles.inputValidColor}`,
            }),
            ...(openCalendar
              ? {
                  borderBottomLeftRadius: 0,
                  borderBottomRightRadius: 0,
                }
              : {
                  borderBottomLeftRadius: appStyles.inputBorderRadius,
                  borderBottomRightRadius: appStyles.inputBorderRadius,
                }),
          }}
          onClick={onInputClick}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <CheckCircle style={{ color: appStyles.inputValidColor, marginLeft: '14px' }} />
            <div style={{ margin: "0 10px", color: "inherit" }}>
              <span>
                {moment
                  .tz(moment(selectedDate || new Date()), timeZone)
                  .format("MMM D, YYYY")}
              </span>{" "}
              {isToday && <span>{T("(Today)")}</span>}
            </div>
          </div>
          <ChevronDownIcon
            className={classnames(
              styles.ChevronDownIcon,
              openCalendar && styles.CalendarOpened,
            )}
          />
        </div>
        {openCalendar && (
          <div
            className={styles.DayPickerContainer}
            style={{
              borderRadius: appStyles.inputBorderRadius,
              ...appStyles.Input,
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0,
              background: appStyles.inputOnCardBackgroundColor,
              color: appStyles.inputOnCardTextColor,
            }}
          >
            <DayPicker
              onDayClick={onDaySelected}
              selectedDays={moment
                .tz(moment(selectedDate || new Date()), timeZone)
                .toDate()}
              months={localeDates[appStyles.locale || "en-US"].MONTHS}
              weekdaysLong={
                localeDates[appStyles.locale || "en-US"].WEEKDAYS_LONG
              }
              weekdaysShort={
                localeDates[appStyles.locale || "en-US"].WEEKDAYS_SHORT
              }
              fromMonth={branchAvailability.futureOrderInterval.before}
              toMonth={branchAvailability.futureOrderInterval.after}
              className={classnames(
                styles.DayPicker,
                appStyles.rtl && styles.RTL,
              )}
              modifiers={{
                disabled: [
                  { daysOfWeek: branchAvailability.branchClosedDays },
                  branchAvailability.futureOrderInterval,
                  ...(isClosedForToday ? [moment.tz(timeZone).toDate()] : [])
                ],
              }}
              modifiersStyles={{
                selected: { ...appStyles.Button, borderRadius: 100 },
              }}
              firstDayOfWeek={
                _.isNumber(appStyles.firstDayOfWeek)
                  ? appStyles.firstDayOfWeek
                  : localeDates[appStyles.locale || "en-US"].firstDayOfWeek
              }
              month={branchAvailability.futureOrderInterval.before}
              renderDay={renderDay}
            />
          </div>
        )}
      </div>
    </div>
  );
}
